module.exports = __webpack_public_path__ + "img/v1-dropdown-mobile.8be760a7.png";